import { ArrowRight } from '@lt/components/icons-react';
import { addMonths, subMonths } from 'date-fns';
import React, { Dispatch, SetStateAction } from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import styled from 'styled-components';

type RenderCustomHeaderProps = {
  isMobile: boolean;
  setStartCurrentMonth: Dispatch<SetStateAction<Date>>;
};

export const renderCustomHeader =
  ({ isMobile, setStartCurrentMonth }: RenderCustomHeaderProps) =>
  ({
    monthDate,
    customHeaderCount,
    decreaseMonth,
    increaseMonth,
  }: ReactDatePickerCustomHeaderProps) => {
    const previousBtnHidden = !isMobile && customHeaderCount === 1;
    const nextBtnHidden = !isMobile && customHeaderCount === 0;

    const handleDecreaseMonth = () => {
      decreaseMonth();
      setStartCurrentMonth((prevState) => subMonths(prevState, 1));
    };

    const handleIncreaseMonth = () => {
      increaseMonth();
      setStartCurrentMonth((prevState) => addMonths(prevState, 1));
    };

    return (
      <StyledHeaderContainer>
        <StyledArrow
          $left
          height={24}
          style={previousBtnHidden ? { visibility: 'hidden' } : undefined}
          onClick={handleDecreaseMonth}
        />
        <span className="react-datepicker__current-month">
          {monthDate
            .toLocaleString('ru', {
              month: 'long',
              year: 'numeric',
            })
            .slice(0, -3)}
        </span>
        <StyledArrow
          height={24}
          style={nextBtnHidden ? { visibility: 'hidden' } : undefined}
          onClick={handleIncreaseMonth}
        />
      </StyledHeaderContainer>
    );
  };

const StyledArrow = styled(ArrowRight)<{ $left?: boolean }>`
  cursor: pointer;
  ${({ $left }) => $left && `transform: rotate(180deg);`}
`;

const StyledHeaderContainer = styled.div`
  display: flex;
  padding: 0px 24px;
  justify-content: space-between;
  align-items: flex-start;
`;
